import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  const getTrendIcon = (trend: string) => {
    switch (trend) {
      case 'up':
        return 'ri-arrow-up-line text-green-500';
      case 'hot':
        return 'ri-fire-line text-red-500';
      default:
        return 'ri-subtract-line text-foreground-400';
    }
  };

  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            大家都在讨论的影视热点
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 px-4 py-3 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 cursor-pointer transition-all duration-200"
            >
              <span className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className={getTrendIcon(topic.trend)}></i>
                {topic.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}